import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <PluginOutlet
  @name="above-latest-topic-list-item"
  @connectorTagName="div"
  @outletArgs={{hash topic=this.topic}}
/>
<div class="topic-poster">
  <UserLink @user={{this.topic.lastPosterUser}}>
    {{avatar this.topic.lastPosterUser imageSize="large"}}
  </UserLink>
  <UserAvatarFlair @user={{this.topic.lastPosterUser}} />
</div>
<div class="main-link">
  <div class="top-row">
    {{raw "topic-status" topic=this.topic}}
    {{topic-link this.topic}}
    {{~#if this.topic.featured_link}}
      &nbsp;{{topic-featured-link this.topic}}
    {{/if}}{{! intentionally inline 
    to avoid whitespace}}<TopicPostBadges
      @unreadPosts={{this.topic.unread_posts}}
      @unseen={{this.topic.unseen}}
      @url={{this.topic.lastUnreadUrl}}
    />
  </div>
  <div class="bottom-row">
    {{category-link this.topic.category}}{{discourse-tags
      this.topic
      mode="list"
    }}{{! intentionally inline to avoid whitespace}}
  </div>
</div>
<div class="topic-stats">
  <PluginOutlet
    @name="above-latest-topic-list-item-post-count"
    @connectorTagName="div"
    @outletArgs={{hash topic=this.topic}}
  />
  {{raw "list/posts-count-column" topic=this.topic tagName="div"}}
  <div class="topic-last-activity">
    <a
      href={{this.topic.lastPostUrl}}
      title={{this.topic.bumpedAtTitle}}
    >{{format-date this.topic.bumpedAt format="tiny" noTitle="true"}}</a>
  </div>
</div>
*/
{
  "id": "Wb3nQiwT",
  "block": "[[[8,[39,0],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-latest-topic-list-item\",\"div\",[28,[37,1],null,[[\"topic\"],[[30,0,[\"topic\"]]]]]]],null],[1,\"\\n\"],[10,0],[14,0,\"topic-poster\"],[12],[1,\"\\n  \"],[8,[39,2],null,[[\"@user\"],[[30,0,[\"topic\",\"lastPosterUser\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,3],[[30,0,[\"topic\",\"lastPosterUser\"]]],[[\"imageSize\"],[\"large\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[39,4],null,[[\"@user\"],[[30,0,[\"topic\",\"lastPosterUser\"]]]],null],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"main-link\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"top-row\"],[12],[1,\"\\n    \"],[1,[28,[35,5],[\"topic-status\"],[[\"topic\"],[[30,0,[\"topic\"]]]]]],[1,\"\\n    \"],[1,[28,[35,6],[[30,0,[\"topic\"]]],null]],[41,[30,0,[\"topic\",\"featured_link\"]],[[[1,\"       \"],[1,[28,[35,8],[[30,0,[\"topic\"]]],null]],[1,\"\\n    \"]],[]],null],[8,[39,9],null,[[\"@unreadPosts\",\"@unseen\",\"@url\"],[[30,0,[\"topic\",\"unread_posts\"]],[30,0,[\"topic\",\"unseen\"]],[30,0,[\"topic\",\"lastUnreadUrl\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"bottom-row\"],[12],[1,\"\\n    \"],[1,[28,[35,10],[[30,0,[\"topic\",\"category\"]]],null]],[1,[28,[35,11],[[30,0,[\"topic\"]]],[[\"mode\"],[\"list\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"topic-stats\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-latest-topic-list-item-post-count\",\"div\",[28,[37,1],null,[[\"topic\"],[[30,0,[\"topic\"]]]]]]],null],[1,\"\\n  \"],[1,[28,[35,5],[\"list/posts-count-column\"],[[\"topic\",\"tagName\"],[[30,0,[\"topic\"]],\"div\"]]]],[1,\"\\n  \"],[10,0],[14,0,\"topic-last-activity\"],[12],[1,\"\\n    \"],[10,3],[15,6,[30,0,[\"topic\",\"lastPostUrl\"]]],[15,\"title\",[30,0,[\"topic\",\"bumpedAtTitle\"]]],[12],[1,[28,[35,12],[[30,0,[\"topic\",\"bumpedAt\"]]],[[\"format\",\"noTitle\"],[\"tiny\",\"true\"]]]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"plugin-outlet\",\"hash\",\"user-link\",\"avatar\",\"user-avatar-flair\",\"raw\",\"topic-link\",\"if\",\"topic-featured-link\",\"topic-post-badges\",\"category-link\",\"discourse-tags\",\"format-date\"]]",
  "moduleName": "discourse/components/latest-topic-list-item.hbs",
  "isStrictMode": false
});